import { getPath } from '@/router/common'

const baseUrl = {
  title: 'AI工具箱',
  path: 'AIToolBox'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'AIToolBoxIndex',
    component: () => import(/* webpackChunkName: "AIToolBoxIndex" */ '@/views/AITool/AIToolBox.vue'),
    meta: {
      title: 'AI工具箱'
    }
  },
  /* 智能配载 开单 */
  {
    path: getPath('AIOrderStowage', baseUrl),
    name: 'AIOrderStowage',
    component: () => import(/* webpackChunkName: "AIOrderStowage" */ '@/views/AIStowage/OrderStowage.vue'),
    meta: {
      title: '智能配载开单'
    }
  },
  /* 智能配载  fdpz*/
  {
    path: getPath('AIFdpzStowage', baseUrl),
    name: 'AIFdpzStowage',
    component: () => import(/* webpackChunkName: "AIFdpzStowage" */ '@/views/AIStowage/AIFdpzStowage.vue'),
    meta: {
      title: '智能配载开单'
    }
  },
]
